import {
  SettingChangedEvent,
  SettingChangedLocation,
  StudentEvent,
} from '@/common/types/studentEvents';
import { ArrowRightIcon, GearIcon } from '@phosphor-icons/react';
import { Badge } from '@shadcn/components/badge';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@shadcn/components/popover';
import dayjs from 'dayjs';

interface SettingChangeItemProps {
  event: StudentEvent & SettingChangedEvent;
  studentName: string;
}
export default function SettingChangeItem({
  event,
  studentName,
}: SettingChangeItemProps) {
  const getSettingChangedDisplayLocation = (
    location: SettingChangedLocation,
  ) => {
    switch (location) {
      case 'game':
        return 'In-Game Settings';
      case 'learner-details':
        return 'Learner Settings';
      case 'org-wide-settings':
        return 'Default Learner Settings';
      case 'bulk-settings':
        return 'Bulk Settings';
      case 'group-settings':
        return 'Group Settings';
    }
  };

  return (
    <div className="flex w-full mt-2">
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center w-7 h-7 rounded-lg bg-purple-400 text-white mb-1">
          <GearIcon size={20} />
        </div>
        <div className="h-[calc(100%-44px)] bg-border w-px" />
      </div>

      <div className="flex flex-col gap-2 ml-2 w-full mb-3">
        <div className="text-sm font-medium mt-1">
          {event.actor.type === 'educator' ? event.actor.name : studentName}{' '}
          changed{' '}
          {event.changes.length === 1 ? (
            <>
              <Badge variant="secondary">{event.changes[0].setting}</Badge> to{' '}
              <Badge variant="secondary">{event.changes[0].newValue}</Badge>
            </>
          ) : (
            <Popover>
              <PopoverTrigger>
                <Badge variant="outline">{event.changes.length} settings</Badge>
              </PopoverTrigger>
              <PopoverContent align="start" className="size-full">
                <div className="flex flex-col gap-4">
                  {event.changes.map((change, i) => (
                    <span key={i} className="flex items-center gap-2">
                      <Badge variant="secondary">{change.setting}</Badge>
                      <ArrowRightIcon />
                      <Badge variant="secondary">{change.newValue}</Badge>
                    </span>
                  ))}
                </div>
              </PopoverContent>
            </Popover>
          )}
          {'location' in event && (
            <>
              {' '}
              in{' '}
              <Badge variant="secondary">
                {getSettingChangedDisplayLocation(event.location)}
              </Badge>
            </>
          )}
          <span className="ml-2 text-neutral-400 text-xs">
            {dayjs(event.createdAt).fromNow()}
          </span>
        </div>
      </div>
    </div>
  );
}
